rdefine('app/products/collections/Categories',['backbone'],function(Backbone) {

    var Category = Backbone.Ribs.Model.extend({
        initialize:function(options) {

        }
    });

    return Backbone.Ribs.Collection.extend({
        allcats: [],
        model: Category,
        initialize:function(els, options) {

            this.on("select",this.loadCategoryId.bind(this));
            $.getJSON(window.categoriesurl,{

            },function(item){
                this.allcats = item;
                this.appendFirst();
                if(options.category_id) {
                    this.loadCategoryId(options.category_id);
                }
            }.bind(this));
        },
        cid:null,
        loadCategoryId:function(category_id) {
            this.cid= category_id;
            //buid path from category id
            var set = [];
            var pid = category_id;

            for(var i = category_id, x = 0 ; x < 100; x++ ) {
                var cats = _.map(_.where(this.allcats,{parent_id:i}),function(item) {
                    item.active = item.id==pid;
                    return item;
                });

                if(cats.length) {
                    set.push({"cats":cats});
                }
                if(i==null) {
                    break;
                }

                var cat = _.findWhere(this.allcats,{"id":i});
                i = cat.parent_id;
                pid = cat.id;
            }
            this.reset(set.reverse());
            this.trigger("vischange",this.canAdd(),this.cid);
        },
        appendFirst: function() {
            this.reset([{"cats":_.where(this.allcats,{parent_id:null})}]);
        },
        canAdd: function() {
            var cat = _.findWhere(this.allcats,{id:this.cid});
            if(cat && !cat.childs_count) {
                return true;
            }
            return false;
        }
    });
});